module.exports = __webpack_public_path__ + "static/img/ACopy.1a8e0497.png";